import React, { useState, useEffect } from "react";
import clsx from 'clsx';
import { ErrorMessage, FormikProps } from 'formik'
import { traverseKeyObj } from 'app/utils/keys';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Editor } from "react-draft-wysiwyg";
import { convertToRaw, ContentState, EditorState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";


export type AreaInputFieldProps = {
    value: string;
    setFieldValue: (val: string) => void;
    toolbar?: any;
    style?: any;
}

export const WysiswygAreaInput = ({ value, setFieldValue, toolbar, style }: AreaInputFieldProps) => {
    const prepareDraft = (value: string) => {
        const draft = htmlToDraft(value);
        const contentState = ContentState.createFromBlockArray(draft.contentBlocks);
        const editorState = EditorState.createWithContent(contentState);
        return editorState;
    };

    const [editorState, setEditorState] = useState(
        value ? prepareDraft(value) : EditorState.createEmpty()
    );

    const onEditorStateChange = (editorState: EditorState) => {
        const forFormik = draftToHtml(
            convertToRaw(editorState.getCurrentContent())
        );
        setFieldValue(forFormik);
        setEditorState(editorState);
    };
    return (
        <div>
            <Editor
                toolbar={toolbar ?? {options:["link"]}}
                editorState={editorState}
                wrapperClassName="tp-wysiwg-wrapper"
                editorClassName="tp-wysiwg-editor"
                onEditorStateChange={onEditorStateChange}
                customStyleMap={style}
            />
        </div>
    );
}

export default WysiswygAreaInput;
